import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import $ from "jquery";
import { useEffect, useRef } from "react";

const TablasClientes = ({ datos, columnas, id = "", onActionClick, defaultOrder}) => {
    const tableRef = useRef();

    useEffect(() => {
        // Procesar columnas para manejar acciones
        const processedColumns = columnas.map((col, index) => {
            if (col.actions) {
                return {
                    ...col,
                    className: "text-center",
                    render: (data, type, row) => {
                        return col.actions.map((action, actionIndex) => {
                            const btnClass = action.className || 'btn btn-outline-primary btn-sm';
                            const icon = action.icon ? `<i class="${action.icon}"></i>` : action.text || '';
                            const title = action.title || '';
                            return `<button 
                                class="${btnClass}" 
                                title="${title}"
                                data-action="${action.key}"
                                data-row-index="${row.DT_RowIndex || index}"
                                data-column-index="${index}"
                            >
                                ${icon}
                            </button>`;
                        }).join(' ');
                    }
                };
            }
            return col;
        });

        const table = $(tableRef.current).DataTable({
            data: datos,
            columns: processedColumns,
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: true,
            responsive: true,
            stateSave: true,
            order: defaultOrder || [],
            buttons: ["copy", "csv", "excel", "pdf", "print"],
            dom:
                "<'row mb-3'<'col-sm-12 col-md-6 text-left'l><'col-sm-12 col-md-6 text-right'f>>" +
                "<'row mb-3'<'col-sm-12'B>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 a 0 de 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                search: "Buscar:",
                zeroRecords: "Sin resultados encontrados",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
            destroy: true
        });

        // Event listener para manejar clicks en botones de acción
        $(tableRef.current).on('click', 'button[data-action]', function () {
            const actionKey = $(this).data('action');
            const row = table.row($(this).closest('tr'));
            const rowData = row.data();
            const columnIndex = $(this).data('column-index');

            // Encontrar la acción correspondiente
            const column = columnas[columnIndex];
            const action = column.actions?.find(a => a.key === actionKey);

            if (action && action.onClick) {
                action.onClick(rowData, row);
            } else if (onActionClick) {
                onActionClick(actionKey, rowData, row);
            }
        });

        return () => {
            $(tableRef.current).off('click', 'button[data-action]');
            table.destroy();
        };
    }, [datos, columnas, onActionClick]);

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                className="table table-bordered table-hover"
            ></table>
        </div>
    );
};

export default TablasClientes;